const initialState = {
  tickets: {
    visibleFields: "",
    filterFields: "",
  },
  myTickets: {
    visibleFields: "",
    filterFields: "",
  },
  responsibleTickets: {
    visibleFields: "",
    filterFields: "",
  },
  poolTickets: {
    visibleFields: "",
    filterFields: "",
  },
};

const filterReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_TICKETS_FILTER":
      return {
        ...state,
        [action.payload.key]: {
          visibleFields: action.payload.visibleFields || "",
          filterFields: action.payload.filterFields || "",
        },
      };
    case "RESET_ALL_TICKETS_FILTER":
    const resetState = { ...state };
      Object.keys(state).forEach((key) => {
        resetState[key] = {
          visibleFields: "",
          filterFields: "",
        };
      });
      return resetState;
    default:
      return state;
  }
};

export default filterReducer;
